import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const getAllSubject = createAsyncThunk("admin/allSubject", async ({ page, limit, searchData }, { rejectWithValue }) => {
  try {
    let url = `/subject/all`;
    if (page && limit) {
      url += `?page=${page}&limit=${limit}`;
    }
    if (searchData) {
      url += `&search=${searchData}`;
    }
    const response = await apiInstance.get(url, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getSubjectList = createAsyncThunk("admin/SubjectList", async (_, { rejectWithValue }) => {
  try {
    let url = `/subject`;
    const response = await apiInstance.get(url, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getSingleSubject = createAsyncThunk("admin/singleSubject", async (SubjectId, { rejectWithValue }) => {
  try {
    const response = await apiInstance.get(`/subject/${SubjectId}`, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const addSubject = createAsyncThunk("admin/addSubject", async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.post(`/subject/add`, payload, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const editSubject = createAsyncThunk("admin/editSubject", async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.post(`/subject/edit`, payload, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const deleteSubject = createAsyncThunk("admin/deleteSubject", async (selectedId, { rejectWithValue }) => {
  try {
    const response = await apiInstance.delete(`/subject/delete/${selectedId}`, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const initialState = {
  subjectLoading: false,
};

const subjectSlice = createSlice({
  name: "subjectSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllSubject.fulfilled, (state, action) => {
      state.subjectData = action.payload.data;
      state.subjectLoading = false;
    });
    builder.addCase(getSubjectList.fulfilled, (state, action) => {
      state.subjectListData = action.payload.data;
    });
    builder.addCase(getSingleSubject.fulfilled, (state, action) => {
      state.singleSubjectData = action.payload.data;
    });
  },
});
export default subjectSlice.reducer;
